const UPDATE_LAYERS = {
  paintSector(map, layerId, action, hosmanSectorId, value, defaultValue = 'transparent') {
    map.setPaintProperty(layerId, action, ['match', ['get', 'hosman_id'], hosmanSectorId, value, defaultValue]);
  }
}

export default UPDATE_LAYERS;
